define(['jquery', 'common', 'erv_tracking'], function ($, Common, ERVTracking) {

	var ERVBookingRules = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.$bookingWidget = self.$ervBody.find('#booking-widget');
		self.common = new Common();
		self.tracking = new ERVTracking();

		self.calculateTotalValue = function($inputs) {
			var total = 0;

			$inputs.each(function() {
				var $input = $(this),
					current = parseInt($input.val());
				if (!isNaN(current)) {
					total += current;
				}
			});

			return total;
		};
	};

	ERVBookingRules.prototype.businessTravelDaysRule = function ($form) {
		var self = this,
			$inputs = $form.find('input[name^="TravelDays."]'),
			valid = true;

		if ($inputs.length === 0) {
			return false;
		}

		var checkValue = self.calculateTotalValue($inputs),
			type = $inputs.first().parents('.traveldays').data('regioninputtype');
		
		if (type === 'percent') {
			if (checkValue !== 100) {
				valid = false;
			} else {
				$inputs.removeClass('input-validation-error').addClass('input-validation-valid');
			}
		} else if(type === 'days') {
			if (checkValue === 0) {
				valid = false;
			} else {
				$inputs.removeClass('input-validation-error').addClass('input-validation-valid');
			}
		}

		if ($form.find('.input-validation-error').length === 0) {
			$form.find('.custom-validation-message').addClass('hide');
		}

		return valid;
	};

	ERVBookingRules.prototype.travelingPeopleNotHigherThanTotalPeople = function ($childElement) {
		var $container = $childElement.parents('.insurance-fields'),
			inputVal = 0,
			self = this;

		if ($container.length === 0 || $container.find('#Input_HasDailyTravel:checked').length === 0) {
			return false;
		}
		var $input = $container.find('#Input_DailyTravelPersonCount');

		if ($input.length === 0) { return false; }
		inputVal = parseInt($input.val());

		var $totalPeople = $container.find('[data-js="person-count"]');
		var totalPeopleVal = parseInt($totalPeople.val());
		if (!isNaN(inputVal) && !isNaN(totalPeopleVal)) {
			if (inputVal > totalPeopleVal) {
				$input.val(totalPeopleVal);

				var $summary = self.$ervBody.find('.validation-summary-errors'),
					$summaryLi = $summary.find('ul li');

				if ($summaryLi.length === 1) {
					if ($summaryLi.data('errorkey') === "DailyTravelPersonCount") {
						$summary.remove();
					}
				}

				$input.removeClass('input-validation-error');
				$input.parents('.field').find('.custom-validation-message').addClass('hide');
			}
		}
	};

	ERVBookingRules.prototype.syncMedicalAndExcess = function ($input) {
		var showExcess = true,
			self = this;

		if (self.common.framework.checks.isSe()) {
			var $parent = $input.parents('.form-element'),
				$medicalInput = $parent.find('input[data-ismedical="true"]:not(:disabled)'); //medical

			showExcess = false;
			
			if ($medicalInput.is(':checked')) {
				showExcess = true;
			}
		}

		return showExcess;
	};
	
	ERVBookingRules.prototype.isFamily = function ($form) {
		var self = this;
		if (!self.common.framework.checks.isDk()) { return false; }

		var $peopleCount = $form.find('[data-js="person-count"]'),
			$ages = $form.find('[data-js="age-of-people"] input[type="number"]'),
			threeOrMore = false,
			$isFamily = $form.find('[data-js="isfamily"]');

		if($ages.length > 0) {
			threeOrMore = $ages.length >= 3;
		} else {
			threeOrMore = Number($peopleCount.val()) >= 3;
		}

		if (threeOrMore) {
			var $amountOfPeopleContainer = $form.find('#amount-of-people'); //if fileupload
			if ($amountOfPeopleContainer.hasClass('hide')) {
				$isFamily.addClass('hide');
				self.common.forms.disableFormElementsInContainer($isFamily, true);
			} else {
				$isFamily.removeClass('hide');
				self.common.forms.disableFormElementsInContainer($isFamily, false);
			}
		} else {
			$isFamily.addClass('hide');
			$isFamily.find('input').prop('checked', false);
			self.common.forms.disableFormElementsInContainer($isFamily, true);
		}
	};

	ERVBookingRules.prototype.isExtendedCarTechnicalEquipment = function ($form) {
		var self = this,
			$addonFormElement = $form.find('#technicalequipmentextended-addon'),
			$addonCheckbox = $addonFormElement.find('input[data-addonid="044C"]');

		if (!self.common.framework.checks.isDk() || $addonCheckbox.length === 0) { return false; }

		var $totalPrice = $form.find('#TechnicalEquipmentPrice'),
			price = Number($totalPrice.val());

		if (!isNaN(price) && price >= 50000) {
			$addonFormElement.removeClass('hide');
		} else {
			$addonFormElement.addClass('hide');
			$addonCheckbox.prop('checked', false);
			$addonCheckbox.val('');
		}
	};

	ERVBookingRules.prototype.hasReachedPeopleLimit = function($categoryForm, peopleCount) {
		if (typeof ($categoryForm.attr('data-limitpeople')) !== 'undefined') {
			if (Number(peopleCount) >= Number($categoryForm.attr('data-limitpeople'))) {
				return true;
			}
		}
		return false;
	}

	ERVBookingRules.prototype.initHomeInsurance = function () {
		var self = this;
		var $step1 = self.$ervBody.find('#main.bookingselectproductpage'),
			$homeInsuranceLightBox = $step1.find('.home-insurance');

		if ($step1.length !== 1 || $homeInsuranceLightBox.length !== 1) {
			return;
		}

		var $stepTwo = $homeInsuranceLightBox.find('.step-two');

		if (self.$bookingWidget.find('#HomeInsuranceStartDay').val().replace('\u2212', '\u002D') === '-1') {
			var days = 0;

			setTimeout(function () {
				if ($('body div.mfp-wrap').length === 0) {

					self.common.framework.popup.openPopup(
						'.home-insurance',
						{
							elementParse: function(item) {
								$(item.src).removeClass('hide');

								self.tracking.trackEvent('Booking', 'Home Insurance lightbox', 'Home Insurance lightbox displayed');
							}
						},
						true, false
					);

					self.$bookingWidget.find('#HomeInsuranceStartDay').val('0');

					$homeInsuranceLightBox.find('[data-js="show-step-two"]').on('click', function () {
						$stepTwo.removeClass('hide');
						self.tracking.trackEvent('Booking', 'Home Insurance lightbox', 'Clicked Yes');
					});

					$homeInsuranceLightBox.find('[data-js="hide-step-two"]').on('click', function () {
						$.magnificPopup.close();
						self.tracking.trackEvent('Booking', 'Home Insurance lightbox', 'Clicked No');
					});

					$homeInsuranceLightBox.find('#HomeInsurancePeriod input').on('change', function () {
						days = parseInt($(this).val());
					});

					$homeInsuranceLightBox.find('[data-js="set-home-insurance-information"]').on('click', function () {
						// if zero then we just close the popup
						if (days === 0) {
							$.magnificPopup.close();
							return;
						}

						// Set data
						var dateInput = self.$bookingWidget.find("[name='FromDate']").not('[disabled]'),
							date = new Date(dateInput.val());

						date.setDate(date.getDate() + days);

						dateInput.val(date.toLocaleDate('se'));

						self.$bookingWidget.find('#HomeInsuranceStartDay').val(days);

						self.common.forms.activateLoading($(this), false);
						self.common.forms.activateLoading(self.$bookingWidget, false);

						// Re-submit the booking request
						self.$bookingWidget.submit();

						$(this).prop('disabled', true);

						self.tracking.trackEvent('Booking', 'Home Insurance lightbox', 'Selected days: ' + days);
					});
				}
			}, 40);
		}
	}

	ERVBookingRules.prototype.isNisCancellation = function ($categoryForm, overwriteChecked) {
		var self = this;

		if ($categoryForm.data('js') !== 'niscancellation') { return false; }

		var $peopleCount = $categoryForm.find('[data-peoplecount]'),
			$oneForAllContainer = $categoryForm.find('#one-for-all'),
			$inputAllForOneCheckBox = $oneForAllContainer.find('#NisCancellationAllForOne'),
			$inputAllForOneContainer = $categoryForm.find('.field.is-allforone'),
			$cancellationPerPersonPriceContainer = $categoryForm.find('#cancellation-per-person-price'),
			checked = $inputAllForOneCheckBox.prop('checked');

		var $amountOfPeopleContainer = $peopleCount.parents('#cancellationtrip-amount-of-people');  //if fileupload

		if (overwriteChecked != undefined) {
			checked = overwriteChecked;
		}

		if ($peopleCount.data('peoplecount') > 1 && !$amountOfPeopleContainer.hasClass('hide')) {
			$oneForAllContainer.removeClass('hide');
			self.common.forms.disableFormElementsInContainer($oneForAllContainer, false);
			self.common.forms.disableFormElementsInContainer($inputAllForOneContainer, false);
			if (checked) {
				$inputAllForOneContainer.removeClass('hide');
				$cancellationPerPersonPriceContainer.addClass('hide');

			} else {
				$inputAllForOneContainer.addClass('hide');
				$cancellationPerPersonPriceContainer.removeClass('hide');
				self.common.forms.disableFormElementsInContainer($inputAllForOneContainer, true);

				if ($peopleCount.data('peoplecount') > 1 && $categoryForm.find('[name^="PersonPrices["]').length === 1) {
					$(document).trigger({
						type: 'ervBookingWidgetPeopleCount',
						peoplecount: $peopleCount.data('peoplecount'),
						currentCategoryForm: $categoryForm
					});
				}
			}

			return true;
		}

		$oneForAllContainer.addClass('hide');
		$inputAllForOneContainer.addClass('hide');
		$inputAllForOneCheckBox.prop('checked', false);

		if (!$amountOfPeopleContainer.hasClass('hide')) {
			$cancellationPerPersonPriceContainer.removeClass('hide');
		}

		self.common.forms.disableFormElementsInContainer($oneForAllContainer, true);
		self.common.forms.disableFormElementsInContainer($inputAllForOneContainer, true);
	};
	
	ERVBookingRules.prototype.hasDailyTravel = function ($form) {
		var self = this;

		var $hasDailyTravel = $form.find('#Input_HasDailyTravel');
		var $amountOfPeopleContainer = $form.find('[data-js="hasdailytravel"]');
		
		if ($hasDailyTravel.is(':checked')) {
			if ($amountOfPeopleContainer.hasClass('hide')) {
				$amountOfPeopleContainer.removeClass('hide');
				self.common.forms.disableFormElementsInContainer($amountOfPeopleContainer, false);
			}
		} else {
			$amountOfPeopleContainer.addClass('hide');
			$amountOfPeopleContainer.find('input').val('');
			self.common.forms.disableFormElementsInContainer($amountOfPeopleContainer, true);
		}
	};

	ERVBookingRules.prototype.init = function() {

	};

	return ERVBookingRules;
});